import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card } from '@mui/material';
import NotFoundRecords from 'src/components/NotFoundRecords';
import {
  isLoadingSelector,
  successSelector
} from 'src/store/selectors/statusSelector';
import {
  loadBureauReports,
  LOAD_BUREAU_REPORTS
} from 'src/store/actions/bureauReportActions';
import {
  selectBureauReportList,
  selectBureauReportListCount,
  selectBureauReportQueryOptions
} from 'src/store/selectors/bureauReportSelector';
import { ReportType } from 'src/utils/constants/buro-reports';
import MonthlyReportTable from './MonthlyReportTable';
import PartialReportTable from './PartialReportTable';

const BureauReportList = () => {
  const dispatch = useDispatch();
  const bureauReportList = useSelector(selectBureauReportList);
  const count = useSelector(selectBureauReportListCount);
  const { page, reportType } = useSelector(selectBureauReportQueryOptions);
  const loading = useSelector(isLoadingSelector([LOAD_BUREAU_REPORTS.action]));
  const success = useSelector(successSelector([LOAD_BUREAU_REPORTS.action]));

  const handleChangePage = useCallback(
    (event, value) => {
      dispatch(loadBureauReports({ page: value, reportType }));
    },
    [dispatch, reportType]
  );

  if (success && !loading && count === 0) {
    return (
      <Card>
        <NotFoundRecords
          title="NOT_FOUND_RECORDS_MESSAGE.BUREAU_REPORTS_TITLE"
          description="NOT_FOUND_RECORDS_MESSAGE.BUREAU_REPORTS_DESCRIPTION"
        />
      </Card>
    );
  }

  const TableComponent =
    reportType === ReportType.PARTIAL ? PartialReportTable : MonthlyReportTable;

  return (
    <TableComponent
      bureauReportList={bureauReportList}
      count={count}
      page={page}
      handleChangePage={handleChangePage}
      loading={loading}
    />
  );
};

export default BureauReportList;
